// orthoJobView.js — pure selectors for ortho-maps job persistence.
// orthoJob shape: { jobId, status: 'running'|'completed'|'failed', progress, message, updatedAt }

/** Button phase for a path's ortho-maps state. */
export function selectOrthoPhase({ orthoJob, hasMaps2000Folder, isLiveCreating }) {
  const status = orthoJob?.status;
  if (isLiveCreating || status === "running") return "running";
  if (status === "completed") return "done";
  // Legacy paths created before orthoJob existed: a folder means it finished.
  if (!orthoJob && hasMaps2000Folder) return "done";
  return "idle"; // no job, or failed → offer Create Ortho Maps again
}

/** Progress for the loading bar: live value wins, else persisted running value. */
export function selectOrthoProgress({ orthoJob, liveProgress }) {
  if (liveProgress) {
    return { progress: liveProgress.progress || 0, message: liveProgress.message || "" };
  }
  if (orthoJob && orthoJob.status === "running") {
    return { progress: orthoJob.progress || 0, message: orthoJob.message || "" };
  }
  return null;
}

/** Paths whose job is 'running' and not already being polled in this tab. */
export function pathsNeedingReconnect(paths, trackedJobIds) {
  if (!Array.isArray(paths)) return [];
  return paths
    .filter(
      (p) =>
        p?.orthoJob?.status === "running" &&
        p.orthoJob.jobId &&
        !trackedJobIds.has(p.orthoJob.jobId),
    )
    .map((p) => ({ pathId: p.id, jobId: p.orthoJob.jobId }));
}
